export default __webpack_public_path__ + "static/FancyMediaContentSixTeen-87aa4e6105740e6faf895858dccb6a4d.webp";